import { render, staticRenderFns } from "./NewWhatsappProfile.vue?vue&type=template&id=62627293&scoped=true"
import script from "./NewWhatsappProfile.vue?vue&type=script&lang=js"
export * from "./NewWhatsappProfile.vue?vue&type=script&lang=js"
import style0 from "./NewWhatsappProfile.vue?vue&type=style&index=0&id=62627293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62627293",
  null
  
)

export default component.exports